import React from 'react'
import { DashboardReviewContext, Task } from 'constants/interfaces'
import { DashboardReviewProvider, useDashboardReview } from '../../hooks/useDashboardReview'
import { TaskOverviewModal } from '../../TaskOverviewModal'
import { TaskOverviewContentType } from '../../TaskOverviewStackProvider'
import { isMediaAnswer } from '../../model/execution'
import { ReviewEntry, ReviewFilter } from '../../model/dashboardReview'

function ReviewModal({ onClose }: { onClose: () => void }) {
  const review = useDashboardReview()!
  const selected = review.subtasks.find((item) => item.st_id === review.entry.id)
  const content =
    selected && review.entry.media && isMediaAnswer(selected)
      ? {
          contentType: TaskOverviewContentType.MEDIA_SUBTASK_COMPLETING,
          props: { selectedSubtask: selected, targetMediaIndex: review.entry.mediaIndex },
        }
      : { contentType: TaskOverviewContentType.MAIN, props: { selectedSubtaskId: review.entry.id } }
  return <TaskOverviewModal task={review.task} onClose={onClose} isComeFromDashboard content={content} />
}

export function DashboardReviewModal({
  task,
  contexts,
  onClose,
  initialFilter,
  initialEntry,
}: {
  task: Task
  contexts: DashboardReviewContext[]
  onClose: () => void
  initialFilter?: ReviewFilter
  initialEntry?: ReviewEntry
}) {
  return (
    <DashboardReviewProvider task={task} contexts={contexts} initialFilter={initialFilter} initialEntry={initialEntry}>
      <ReviewModal onClose={onClose} />
    </DashboardReviewProvider>
  )
}
